/**
 * Portrait + background changer locale pack: de
 */

module.exports = {
  "portrait": {
    "overview": [
      "Miral AI Background Remover ist nach der Anmeldung kostenlos und eignet sich für Porträts von Kopf und Schultern: LinkedIn-Fotos, Lebenslaufbilder, WeChat- oder Instagram-Avatare und transparente Master für Ausweis-Zuschnitte.",
      "Laden Sie ein scharfes JPG, PNG oder WebP bis 15 MB hoch. Die KI erkennt die Person automatisch. Zoomen Sie vor dem Download auf fliegende Haare, Brille, Ohrringe und die Kragenlinie.",
      "Ein transparentes PNG ist kein fertiges weißes oder blaues Ausweisfoto. Bewahren Sie zuerst den transparenten Master auf, fügen Sie dann die geforderte Farbe hinzu und schneiden Sie auf die offizielle Größe für Ihr Formular zu."
    ],
    "practice": [
      "Ich starte möglichst mit dem Kamera-Original. Chat-App-Thumbnails und starke Beauty-Filter weichen Haarkanten auf und machen Brillengestelle schwerer zu erhalten.",
      "Ich lege den Freisteller immer auf eine helle und eine dunkle Leinwand. Dieser eine Check zeigt blasse Halos und fehlende Strähnen, die in der Miniaturvorschau unauffällig wirken."
    ],
    "compareIntro": "Nutzen Sie diesen Leitfaden für Personen—Avatare, ausweisähnliche Fotos und professionelle Headshots. Für Produkt-Weißhintergründe den E-Commerce-Leitfaden, für Café- oder Büroszenen nach dem Freistellen den Hintergrundwechsel-Leitfaden.",
    "workflow": "Laden Sie ein klares Porträt bis 15 MB hoch, lassen Sie die KI den gesamten Hintergrund entfernen, prüfen Sie Haare und Brille, laden Sie dann ein transparentes PNG herunter, bevor Sie Weiß, Blau oder Markenfarbe ergänzen.",
    "scenarioIntro": "Wählen Sie die Porträtaufgabe, die Ihrer am nächsten kommt, und prüfen Sie die Kanten, die für diesen Anwendungsfall oft scheitern.",
    "sec": {
      "tldrTitle": "Kurzfassung",
      "tldrCols": [
        "Was Sie brauchen",
        "Details"
      ],
      "tldrRows": [
        [
          "Preis",
          "Miral AI Background Remover ist nach Anmeldung kostenlos"
        ],
        [
          "Upload",
          "JPG, PNG oder WebP bis 15 MB"
        ],
        [
          "Am besten für",
          "LinkedIn-Headshots, Lebenslauffotos, Avatare, Ausweis-Master"
        ],
        [
          "Download",
          "Transparentes PNG; Weiß oder Blau danach hinzufügen"
        ],
        [
          "Genau prüfen",
          "Haare, Brille, Ohrringe, Kragen und Schultern"
        ],
        [
          "Nicht dieser Artikel",
          "Marktplatz-Produkt-Weißhintergründe gehören in den E-Commerce-Leitfaden"
        ]
      ],
      "tldrP": "Ein Straßen-Selfie oder ein hastiges Büro-Snapshot kann in Miral AI trotzdem ein sauberer Headshot werden. Person einmal freistellen, die transparente Datei behalten und erst dann die weiße, blaue oder markenfarbene Version bauen, die Sie wirklich brauchen.",
      "whatTitle": "Was Avatare, Ausweisfotos und LinkedIn-Headshots jeweils brauchen",
      "whatP1": "Alle drei Aufgaben teilen denselben ersten Schritt: Person mit Miral AI Background Remover freistellen und ein sauberes transparentes PNG behalten. Der Unterschied liegt in Farbe und Zuschnitt danach.",
      "whatAvatarP": "Was Avatar-Hintergrundentfernung löst: Schlafzimmer-Selfies und Straßenfotos begraben das Gesicht im Chaos. Hintergrund entfernen, Freisteller auf Markenfarbe oder Vollton legen, dann den runden Zuschnitt für Instagram, WeChat oder die persönliche Website prüfen.",
      "galleryAvatarCaption": "Avatar-Beispiel: links ein unruhiges Indoor-Selfie; rechts der Freisteller auf Vollton, bereit für den runden Profilzuschnitt.",
      "whatIdP": "Was Ausweis-Hintergrundentfernung löst: Anträge verlangen oft Weiß oder Blau. Ein Wohnzimmer-Snapshot erfüllt das meist nicht. Einmal freistellen, geforderte Farbe hinzufügen, dann auf die offizielle Größe zuschneiden. Vor dem Einreichen immer die aktuellen Formularregeln prüfen.",
      "galleryIdCaption": "Ausweis-Beispiel: links ein belebter Wohn-Hintergrund; rechts dieselbe Person auf Reinweiß für den Größen-Zuschnitt.",
      "whatLinkedInP": "Was LinkedIn-Headshot-Freistellung löst: Offene Büros setzen Monitore und Kollegen hinter Sie. Ein ruhiges Grau oder Weiß lenkt den Blick zurück auf Gesicht und Kleidung—das Erste, was Recruiter sehen.",
      "galleryLinkedInCaption": "LinkedIn-Beispiel: links ein belebtes Büro-Selfie; rechts der Freisteller auf Softgrau für ein recruiter-taugliches Profil.",
      "whatTipTitle": "Ein transparenter Master für alle drei",
      "whatTipText": "Laden Sie zuerst das transparente PNG herunter. Markenfarben-Avatar, Weiß/Blau-Ausweis-Export und Softgrau-LinkedIn-Karte leiten Sie aus derselben Datei ab.",
      "howTitle": "Vier Schritte zum brauchbaren Headshot",
      "howP": "Öffnen Sie Miral AI Background Remover, laden Sie ein Kopf-Schulter-Foto hoch, warten Sie auf die automatische Erkennung und zoomen Sie vor dem Download auf 100 % bei Haaren und Brille. Weiß oder Blau erst ergänzen, wenn die Kante sauber aussieht.",
      "howTipTitle": "Originaldatei bevorzugen",
      "howTipText": "Starke Beauty-Filter und Messenger-Kompression verwischen fliegende Haare. Das Kamera-Original gewinnt fast immer.",
      "edgeTitle": "Wo Porträts meist scheitern",
      "edgeCols": [
        "Bereich",
        "Häufiger Fehler",
        "So prüfen"
      ],
      "edgeRows": [
        [
          "Fliegende Haare",
          "Strähnen als Hintergrund gelöscht",
          "Auf dunkler und heller Leinwand betrachten"
        ],
        [
          "Brille",
          "Fehlendes Bügelstück oder Loch in der Linse",
          "Zu den Gestell-Ecken zoomen"
        ],
        [
          "Ohrringe / dünne Ketten",
          "Unterbrochene Metalllinien",
          "Schmuckkante nachverfolgen"
        ],
        [
          "Kragen- und Blazerlinie",
          "Weißer Halo oder gezackte Schulter",
          "Auf dunkle Leinwand legen"
        ],
        [
          "Bart oder Koteletten",
          "Stoppeln glattgebügelt",
          "Mit weniger Retusche am Quellbild erneut versuchen"
        ]
      ],
      "edgeP": "„Sieht in der Miniatur okay aus“ reicht nicht. Prüfung in voller Größe auf zwei Hintergrundfarben ist der schnellste Ehrlichkeitstest.",
      "useTitle": "Avatar, LinkedIn, Lebenslauf und ausweisähnliche Fotos",
      "useCols": [
        "Einsatz",
        "Typischer Hintergrund",
        "Praxisnotiz"
      ],
      "useRows": [
        [
          "LinkedIn / Jobbörsen",
          "Softgrau, Weiß oder sauberer Blur",
          "Gesicht scharf halten; ruhige Hintergründe gewinnen"
        ],
        [
          "WeChat- / Instagram-Avatar",
          "Markenfarbe oder einfacher Verlauf",
          "Runden Zuschnitt vor dem Posten prüfen"
        ],
        [
          "Lebenslauf-Anhang",
          "Weiß oder Hellgrau",
          "Platz über dem Kopf und unter den Schultern lassen"
        ],
        [
          "Übliche ausweisähnliche Prints",
          "Weiß oder Blau",
          "Geforderte Farbe auf dem transparenten PNG ergänzen, dann zuschneiden"
        ],
        [
          "Pass- / Visafotos",
          "Aktuellen offiziellen Regeln folgen",
          "Farbe, Ausdruck und Brillenregeln variieren je Land"
        ],
        [
          "Kurs- oder Livestream-Cover",
          "Markenfarbe oder spätere Szene",
          "Zuerst sauber freistellen, dann das Cover gestalten"
        ]
      ],
      "useTipTitle": "Regeln ändern sich",
      "useTipText": "Visa- und Prüfungsfoto-Regeln unterscheiden sich nach Land und Jahr. Das Tool säubert das Motiv; die Compliance kommt weiterhin von der offiziellen Checkliste.",
      "hairTitle": "Haar-Freistellung und Brille",
      "hairItems": [
        "Gegenlicht-Fluglocken brauchen ein einfacheres, kontrastreiches Quellfoto.",
        "Bei Brille prüfen, ob beide Bügel und der Linsenbereich erhalten bleiben.",
        "Dunkles Haar vor dunkler Wand ist ein schlechter Start—wenn möglich näher an eine hellere Wand.",
        "Heller Pullover vor weißer Wand verliert oft die Schulterkante; Aufnahmemotiv wechseln.",
        "Lange Locken und Kinder-Fluglocken verdienen vor dem Download einen Pflicht-Zoom auf 100 %."
      ],
      "hairP": "Große Kleidungsformen ruinieren selten einen Porträt-Freisteller. Haare und Brille tun es. Dort investiere ich die Extra-Minute.",
      "troubleTitle": "Wenn der Headshot falsch aussieht",
      "troubleCols": [
        "Problem",
        "Wahrscheinliche Ursache",
        "Das versuchen"
      ],
      "troubleRows": [
        [
          "Haarpartien fehlen",
          "Weiches, komprimiertes oder gegenlichtiges Quellbild",
          "Scharferes Original mit weniger Beautify nutzen"
        ],
        [
          "Blasser Rand an Gesicht oder Schultern",
          "Alte Hintergrundfarbe klebt an der Kante",
          "Auf dunkler Leinwand prüfen, dann mit mehr Kontrast erneut"
        ],
        [
          "Unterbrochenes Brillengestell",
          "Starke Reflexe verwirren die Kontur",
          "Mit weicherem Licht auf den Linsen neu aufnehmen"
        ],
        [
          "Kleidung verschmilzt mit der Wand",
          "Zu wenig Motiv-/Hintergrundkontrast",
          "Hintergrund wechseln statt dieselbe Datei erneut zu senden"
        ],
        [
          "Ausweisfoto wirkt gelb",
          "Warme Quell-Weißbalance",
          "Zuerst freistellen, Farbe auf der finalen Leinwand neutralisieren"
        ]
      ],
      "troubleTipTitle": "Eingabe ändern",
      "troubleTipText": "Dasselbe weiche Selfie erneut hochladen repariert Haare selten. Ein saubereres Quellbild schon.",
      "prosConsTitle": "Wo es hilft—und wo Sie entscheiden",
      "bestTitle": "Gewohnheiten, die Avatare brauchbar machen",
      "bestItems": [
        "Kopf-Schulter-Framing mit etwas Platz über dem Haar nutzen.",
        "Ausdruck natürlich halten; starke Hautglättung vor dem Freistellen vermeiden.",
        "PNG jedes Mal auf heller und dunkler Leinwand prüfen.",
        "Transparenten Master, farbigen Ausweis-Export und finalen Zuschnitt als getrennte Dateien speichern.",
        "Auf Jobplattformen macht ein ruhiger Hintergrund Gesicht und Kleidung besser lesbar.",
        "Wenn als Nächstes Café- oder Büro-Atmosphäre nötig ist: zuerst sauber freistellen, dann den Hintergrundwechsel-Leitfaden."
      ],
      "miralTitle": "Was nach dem Freistellen kommt",
      "miralP": "In Miral AI können Sie das Porträt schärfen, eine ruhige Avatar-Karte bauen oder mit Seedream oder FLUX.2 eine Cover-Szene fortsetzen. Für Lifestyle-Hintergrundwechsel den AI-Hintergrundwechsel-Leitfaden öffnen. Für Produktlisten-Weiß den E-Commerce-Leitfaden nutzen.",
      "miralLinksTitle": "Nächste Schritte",
      "intentsTitle": "Häufige Porträt-Workflows",
      "faqTitle": "Fragen vor dem Upload",
      "faqItems": [
        [
          "Wie entferne ich einen Porträthintergrund online kostenlos?",
          "Bei Miral AI anmelden, ein JPG-, PNG- oder WebP-Kopf-Schulter-Foto hochladen und das transparente PNG herunterladen."
        ],
        [
          "Wie mache ich aus einem Selfie ein weißes oder blaues Ausweisfoto?",
          "Zuerst transparentes PNG exportieren, gefordertes Weiß oder Blau hinzufügen, auf die offizielle Größe zuschneiden und vor dem Einreichen die aktuellen Regeln prüfen."
        ],
        [
          "Wie erstelle ich einen LinkedIn-Headshot mit Hintergrundentfernung?",
          "Belebten Bürohintergrund entfernen, Freisteller auf Softgrau oder Weiß legen und Haar- sowie Schulterkanten vor dem Upload prüfen."
        ],
        [
          "Kann ich einen WeChat- oder Instagram-Avatar-Hintergrund kostenlos entfernen?",
          "Ja. Anmelden, Avatar-Original verarbeiten, dann den runden Zuschnitt auf Ihrer Markenfarbe prüfen."
        ],
        [
          "Kann man ein Foto mit Brille online freistellen?",
          "Ja, aber vor dem Download Gestell, Bügel und Linsenbereich vergrößern."
        ],
        [
          "Welches Tool eignet sich für Haar-Freistellung bei Porträts?",
          "Miral AI Background Remover mit dem Kamera-Original nutzen und Fluglocken auf heller und dunkler Leinwand prüfen."
        ],
        [
          "Welches Tool bereitet einen Passfoto-Hintergrund vor?",
          "Zuerst einen transparenten Porträt-Master erstellen, dann offizielle Hintergrundfarbe und Millimetergröße exportieren."
        ],
        [
          "Wie behebe ich einen weißen Halo nach Porträt-Hintergrundentfernung?",
          "Transparentes PNG auf dunkle Leinwand legen, den Rand finden, dann mit schärferem, kontrastreicherem Original erneut versuchen."
        ],
        [
          "Wie behebe ich fehlende Fluglocken bei Locken oder Kinderfotos?",
          "Starke Beautify- und Chat-Thumbnails vermeiden. Klareres Original nutzen und vor dem Download bei 100 % prüfen."
        ],
        [
          "Kann ich viele professionelle Headshots auf einmal stapeln?",
          "Die aktuelle Seite verarbeitet ein Bild nach dem anderen, damit jede Haarkante geprüft werden kann."
        ],
        [
          "Was ist der Unterschied zwischen transparentem und weißem Ausweis-Hintergrund?",
          "Ein transparentes PNG kann später jede Farbe aufnehmen. Ein weißer Ausweis-Export enthält bereits Weißpixel für Formulare und Lebensläufe."
        ],
        [
          "Wie ändere ich den Hintergrund danach in eine Café- oder Büroszene?",
          "Nachdem das transparente PNG die Prüfung besteht, dem AI-Hintergrundwechsel-Leitfaden folgen und die Lichtanpassung prüfen."
        ]
      ],
      "miralLinks": [
        {
          "label": "Miral AI Background Remover",
          "path": "/tools/background-remover"
        },
        {
          "label": "AI-Hintergrundwechsel-Leitfaden",
          "path": "/hub/articles/ai-background-changer-online"
        },
        {
          "label": "Allgemeiner AI-Hintergrundentfernungs-Leitfaden",
          "path": "/hub/articles/ai-background-remover-online"
        },
        {
          "label": "E-Commerce-Produkthintergrund-Leitfaden",
          "path": "/hub/articles/ecommerce-product-background-removal"
        },
        {
          "label": "AI Image Enhancer",
          "path": "/tools/image-enhancer"
        },
        {
          "label": "Seedream 5",
          "path": "/image-models/seedream-ai-image-generator"
        },
        {
          "label": "FLUX.2",
          "path": "/image-models/flux-2-ai-image-generator"
        }
      ]
    },
    "linksTitle": "In Miral AI weitermachen",
    "linksIntro": "Transparenten Porträt-Master behalten, dann schärfen, eine Avatar-Karte bauen oder in eine Lifestyle-Szene wechseln.",
    "steps": [
      {
        "title": "Klares Kopf-Schulter-Foto wählen",
        "text": "JPG, PNG oder WebP bis 15 MB mit vollständig sichtbarem Gesicht und Schultern nutzen."
      },
      {
        "title": "Hintergrund automatisch entfernen",
        "text": "Miral AI Background Remover erkennt die Person und löscht den gesamten Hintergrund—keine manuelle Kontur."
      },
      {
        "title": "Haare und Brille prüfen",
        "text": "Auf Fluglocken, Gestelle, Ohrringe und die Kragenlinie zoomen."
      },
      {
        "title": "Transparentes PNG herunterladen, dann Farbe ergänzen",
        "text": "Master behalten, dann Weiß, Blau, Grau oder Markenfarbe für den Endzweck hinzufügen."
      }
    ],
    "pros": [
      "Für Porträtkanten in Avataren und ausweisähnlichen Fotos gebaut",
      "Kein Photoshop-Stiftwerkzeug für Haare nötig",
      "Ein transparentes PNG kann viele Hintergrundfarben werden",
      "Kostenlose Verarbeitung im Browser nach Anmeldung"
    ],
    "cons": [
      "Feine Haare brauchen trotzdem eine Prüfung in voller Größe",
      "Gegenlicht oder niedriger Kontrast kann Kanten aufweichen",
      "Auf der aktuellen Seite ein Bild nach dem anderen",
      "Offizielle Ausweisregeln erfordern weiterhin manuelle Compliance-Prüfung"
    ],
    "tips": [
      {
        "title": "Zwei Leinwandfarben prüfen",
        "text": "Helle und dunkle Hintergründe zeigen Halos und fehlende Strähnen schnell."
      },
      {
        "title": "Brille und Schmuck schützen",
        "text": "Vor dem Download zu Bügeln, Linsenecken und dünnen Ketten zoomen."
      },
      {
        "title": "Master und Ausweis-Export trennen",
        "text": "Transparentes PNG nicht mit einer flachen Weiß- oder Blau-Datei überschreiben."
      },
      {
        "title": "Filter leicht halten",
        "text": "Starke Beautify weicht genau die Kanten auf, die das Modell braucht."
      },
      {
        "title": "Wissen, welchen Leitfaden als Nächstes öffnen",
        "text": "Szenenersatz → Hintergrundwechsler. Produktweiß → E-Commerce-Leitfaden."
      }
    ],
    "scenarios": [
      {
        "title": "LinkedIn-Headshot-Hintergrundentfernung",
        "text": "Scharfes Kopf-Schulter-Foto freistellen, dann vor dem Upload auf Softgrau oder Weiß legen."
      },
      {
        "title": "WeChat- oder Instagram-Avatar-Freistellung",
        "text": "Transparentes PNG herunterladen und den runden Zuschnitt auf Ihrer Markenfarbe prüfen."
      },
      {
        "title": "Lebenslauf-Foto Weißhintergrund",
        "text": "Transparenten Master behalten, dann eine separate Weißhintergrund-Datei für das PDF exportieren."
      },
      {
        "title": "Blaues ausweisähnliches Foto",
        "text": "Gefordertes Blau erst ergänzen, wenn die Haarkante sauber aussieht."
      },
      {
        "title": "Hintergrund um Haare online entfernen",
        "text": "Kamera-Original nutzen und Fluglocken auf heller und dunkler Leinwand prüfen."
      },
      {
        "title": "Porträt-Freistellung mit Brille",
        "text": "Zu Gestell-Ecken und Bügeln zoomen, bevor Sie dem Download vertrauen."
      },
      {
        "title": "Passfoto-Vorbereitung",
        "text": "Zuerst transparentes PNG erstellen, dann den aktuellen Größen- und Farbregeln des Landes folgen."
      },
      {
        "title": "Büro-Selfie zum professionellen Headshot",
        "text": "Flur-Chaos entfernen, natürlichen Ausdruck behalten, starke Filter vermeiden."
      },
      {
        "title": "Kinder- oder Lockenhaar-Freistellung",
        "text": "Mehr Fluglocken erwarten; immer bei 100 % Zoom prüfen."
      },
      {
        "title": "Transparent vs. weißer Porträthintergrund",
        "text": "Transparent bleibt wiederverwendbar; Weiß ist ein flacher Export für ein bestimmtes Formular."
      },
      {
        "title": "Weißen Halo am Gesichts-Freisteller beheben",
        "text": "Rand auf dunkler Leinwand bestätigen, dann mit stärkerem Quellkontrast erneut versuchen."
      },
      {
        "title": "Vom Porträt-Freisteller zur Café-Szene",
        "text": "Hintergrundwechsel-Leitfaden nutzen, nachdem das transparente PNG die Prüfung besteht."
      }
    ],
    "toolFaq": [
      {
        "q": "Wie entferne ich einen Porträthintergrund online kostenlos?",
        "a": "Anmelden, Porträt hochladen und transparentes PNG ohne Desktop-Software herunterladen."
      },
      {
        "q": "Wie mache ich aus einem Selfie ein weißes oder blaues Ausweisfoto?",
        "a": "Hintergrund entfernen, transparentes PNG behalten, geforderte Farbe ergänzen, dann auf die offizielle Größe zuschneiden."
      },
      {
        "q": "Kann ich einen WeChat- oder Instagram-Avatar-Hintergrund kostenlos entfernen?",
        "a": "Ja. Avatar-Original nach Anmeldung verarbeiten, dann den runden Zuschnitt auf Ihrer Markenfarbe prüfen."
      },
      {
        "q": "Kann man ein Foto mit Brille online freistellen?",
        "a": "Ja, aber Bügel und Linsenbereiche vor dem Download in voller Größe prüfen."
      },
      {
        "q": "Welches Tool eignet sich für Haar-Freistellung bei Porträts?",
        "a": "Miral AI Background Remover mit scharfem Original nutzen und Fluglocken auf heller und dunkler Leinwand prüfen."
      },
      {
        "q": "Welches Tool bereitet einen Passfoto-Hintergrund vor?",
        "a": "Zuerst transparenten Porträt-Master erstellen, dann offizielle Farbe und Größe laut Formular exportieren."
      },
      {
        "q": "Wie behebe ich einen weißen Halo nach Porträt-Hintergrundentfernung?",
        "a": "Rand auf dunkler Leinwand bestätigen, dann mit schärferem, kontrastreicherem Quellbild erneut versuchen."
      },
      {
        "q": "Wie behebe ich fehlende Fluglocken bei Locken oder Kinderfotos?",
        "a": "Starke Beautify- und Chat-Thumbnails vermeiden; klareres Original nutzen und bei 100 % prüfen."
      },
      {
        "q": "Kann ich viele professionelle Headshots auf einmal stapeln?",
        "a": "Die aktuelle Seite verarbeitet ein Bild nach dem anderen."
      },
      {
        "q": "Wie ändere ich den Hintergrund danach in eine Café-Szene?",
        "a": "Geprüftes transparentes PNG mit dem AI-Hintergrundwechsel-Workflow nutzen."
      }
    ],
    "links": [
      {
        "label": "Miral AI Background Remover",
        "path": "/tools/background-remover"
      },
      {
        "label": "AI-Hintergrundwechsel-Leitfaden",
        "path": "/hub/articles/ai-background-changer-online"
      },
      {
        "label": "Allgemeiner AI-Hintergrundentfernungs-Leitfaden",
        "path": "/hub/articles/ai-background-remover-online"
      },
      {
        "label": "E-Commerce-Produkthintergrund-Leitfaden",
        "path": "/hub/articles/ecommerce-product-background-removal"
      },
      {
        "label": "AI Image Enhancer",
        "path": "/tools/image-enhancer"
      },
      {
        "label": "Seedream 5",
        "path": "/image-models/seedream-ai-image-generator"
      },
      {
        "label": "FLUX.2",
        "path": "/image-models/flux-2-ai-image-generator"
      }
    ]
  },
  "changer": {
    "overview": [
      "Hintergrundwechsel funktioniert am besten in zwei Schritten: kostenlose Hintergrundentfernung zu einem sauberen transparenten PNG, dann Platzierung in eine neue Szene—Cafélicht, ruhiges Büro, Markenwand oder Außenlicht.",
      "Miral AI Background Remover übernimmt den Freisteller. Seedream oder FLUX.2 können danach Lifestyle-Szenen bauen. Nicht mit Amazon-ähnlichen Reinweiß-Produktplatten verwechseln; dieser Workflow steht im E-Commerce-Leitfaden.",
      "Hat der Freisteller noch einen blassen Rand, wirkt jede neue Szene unecht. Zuerst Kanten reparieren, dann Atmosphäre bedenken."
    ],
    "practice": [
      "Ich komponiere nicht, bevor das transparente Motiv auf heller und dunkler Leinwand sauber aussieht.",
      "Ich gleiche die Lichtrichtung ab, bevor ich „schön“ abgleiche. Ein fensterbeleuchtetes Porträt auf einer Neon-Nachtstraße täuscht kaum jemanden."
    ],
    "compareIntro": "Hintergrundentfernung für den transparenten Master, diesen Leitfaden für Lifestyle- oder Cover-Szenen, den Porträt-Leitfaden für ausweisähnliche Farben und den E-Commerce-Leitfaden für Marktplatz-Weißhintergründe.",
    "workflow": "Motiv freistellen, eine zum Licht passende Szene wählen, neue Umgebung komponieren oder generieren, dann Kontaktschatten, Farbtemperatur und Kanten vor dem Export prüfen.",
    "scenarioIntro": "Zuerst das Szenenziel wählen, dann den transparenten Master von jedem fertigen Zuschnitt getrennt halten.",
    "sec": {
      "tldrTitle": "Die Reihenfolge, die wirklich funktioniert",
      "tldrCols": [
        "Schritt",
        "Behalten",
        "Achtung"
      ],
      "tldrRows": [
        [
          "1. Hintergrund entfernen",
          "Miral AI transparenter PNG-Master",
          "Alte Halos ruinieren jede spätere Szene"
        ],
        [
          "2. Szene wählen",
          "Café, Büro, Markenwand, Outdoor",
          "Für den Job wählen, nicht nach Zufallsästhetik"
        ],
        [
          "3. Komponieren oder generieren",
          "Lifestyle- oder Cover-Bild",
          "Lichtrichtung und Farbtemperatur abstimmen"
        ],
        [
          "4. Prüfen",
          "Veröffentlichungsfertiger Export",
          "Kanten, Maßstab und Kontaktgefühl"
        ],
        [
          "Von Weißplatten trennen",
          "E-Commerce-Leitfaden für weiße SKUs",
          "Dieser Artikel ist für Szenenersatz"
        ]
      ],
      "tldrP": "Einen Hintergrund ändern ist kein einzelner Magiefilter. In Miral AI isolieren Sie das Motiv mit Background Remover und geben ihm dann einen neuen Standplatz. Den ersten Job überspringen, und der zweite wirkt fast immer aufgeklebt.",
      "removeTitle": "Lifestyle-Bilder, Social-Cover und Event-Poster brauchen jeweils eine andere Platte",
      "removeP1": "Alte Wandfarben kleben an Haar- und Jackenkanten. Der stabile Weg bleibt gleich: Miral AI Background Remover → transparenter PNG-Master → neue Szene für den Job. Marktplatz-Weißproduktplatten gehören in den E-Commerce-Leitfaden, nicht hierher.",
      "removeLifestyleP": "Was Lifestyle-Hintergrundwechsel löst: Cafélicht, Fensterplätze und Wohnecken schaffen Atmosphäre—aber ein unruhiges Original lässt den ganzen Frame billig wirken. Sauber freistellen, dann die Person in eine Szene setzen, deren Licht zum Gesicht passt.",
      "galleryLifestyleCaption": "Lifestyle-Beispiel: links der transparente Master; rechts dieselbe Person in eine helle Café-Szene komponiert.",
      "removeSocialP": "Was Social-Cover-Hintergrundwechsel löst: Instagram-, Xiaohongshu- und LinkedIn-Header brauchen ein klares Gesicht plus Platz für einen Titel. Ein unruhiges Schlafzimmer oder Open Office überfüllt den Frame. Ein Markenverlauf oder eine ruhige Farbwand setzt die Person auf eine Seite und lässt die andere für Copy frei.",
      "gallerySocialCaption": "Social-Cover-Beispiel: links der transparente Master; rechts eine Markenverlauf-Wand mit Platz für eine Headline.",
      "removePosterP": "Was Event-Poster-Hintergrundwechsel löst: Webinare, Kursstarts und Talk-Ankündigungen brauchen eine ruhige Bühne oder Markenwand—kein Schreibtisch-Selfie. Nach dem Freistellen die Person auf eine weiche Markenplatte mit Freiraum für den Titel setzen, bei Bedarf Schrift in GPT Image ergänzen.",
      "galleryPosterCaption": "Event-Poster-Beispiel: links der transparente Master; rechts eine weiche Markenwand für Talk- oder Kurscover.",
      "removeTipTitle": "Master, Szene und Cover-Zuschnitte getrennt halten",
      "removeTipText": "Transparentes PNG nicht mit einem Café- oder Verlauf-Export überschreiben. Das Poster der nächsten Saison soll denselben Freisteller wiederverwenden.",
      "howTitle": "Ein praktischer Online-Workflow",
      "howP": "Öffnen Sie zuerst Miral AI Background Remover und holen Sie ein vertrauenswürdiges transparentes Motiv. Dann Hintergrundtyp wählen: Vollton ist am schnellsten, eine echte Fotoplatte als Nächstes, eine KI-generierte Umgebung am flexibelsten. Vor dem Export prüfen, ob die Person noch vom selben Licht wie der Hintergrund beleuchtet wirkt.",
      "howTipTitle": "Licht schlägt Dekoration",
      "howTipText": "Ein ruhigerer Hintergrund mit passendem Licht schlägt eine dramatische Szene, die dem Gesicht widerspricht.",
      "sceneTitle": "Szenenideen, die oft klicken",
      "sceneCols": [
        "Richtung",
        "Gut für",
        "Achtung"
      ],
      "sceneRows": [
        [
          "Helles Café / Fensterplatz",
          "Personal Brand und Lifestyle-Cover",
          "Warme Glühbirnen können Haut zu orange drücken"
        ],
        [
          "Ruhiges Büro / weicher Bücherregal-Blur",
          "LinkedIn und Kurs-Mentor-Bilder",
          "Hintergrund-Requisiten sollten leiser bleiben als das Gesicht"
        ],
        [
          "Außenlicht und Grün",
          "Reise-, Wellness-, Lifestyle-Posts",
          "Hartes Mittags-Oberlicht vermeiden, das dem Original widerspricht"
        ],
        [
          "Vollton- oder weiche Markenverlauf-Wand",
          "Event-Poster und Social-Header",
          "Kontrast für Overlay-Text hoch genug halten"
        ],
        [
          "Bühnen- oder Keynote-Licht",
          "Talk-Ankündigungen",
          "Flares sollten nicht übers Gesicht laufen"
        ],
        [
          "Home-Lifestyle-Ecke",
          "Weiches Produkt-Storytelling",
          "Perspektive und Personenmaßstab konsistent halten"
        ]
      ],
      "sceneP": "Klickwürdig heißt oft klar, nicht überladen. Eine saubere Person auf einem ruhigen, bewussten Hintergrund schlägt oft eine belebte Collage.",
      "qualityTitle": "Fünf Stellen, an denen Fakes auffallen",
      "qualityItems": [
        "Haare und Schultern: übrig gebliebene weiße oder farbige Fransen vom alten Raum.",
        "Lichtrichtung: Gesichtshighlight und Fensterlicht sollten übereinstimmen.",
        "Farbtemperatur: warme Innenhaut auf kalter blauer Platte wirkt gespalten.",
        "Maßstab: die Person sollte nicht wie ein Sticker schweben oder in die falsche Tiefe schrumpfen.",
        "Kontakt: ein Hauch Boden- oder Stuhlkontakt macht die Komposition glaubwürdig."
      ],
      "qualityTipTitle": "Zuschnitt früh prüfen",
      "qualityTipText": "Quadratischen Avatar-Zuschnitt und breiten Cover-Zuschnitt prüfen, bevor Sie die finale Szene festlegen.",
      "vsTitle": "Wie sich dieser Artikel von den anderen trennt",
      "vsCols": [
        "Leitfaden",
        "Hauptaufgabe",
        "Öffnen wenn"
      ],
      "vsRows": [
        [
          "Allgemeiner AI-Hintergrundentferner",
          "Beliebiges Motiv → transparentes PNG",
          "Sie brauchen nur den Freisteller"
        ],
        [
          "E-Commerce-Produkthintergrund",
          "Weiße / transparente Produktplatten",
          "Amazon-, Shopify-Listing-Compliance"
        ],
        [
          "Porträt-Hintergrundentferner",
          "Avatare und ausweisähnliche Farben",
          "Gesichter, Haare, Weiß/Blau-Ausweis-Master"
        ],
        [
          "AI-Hintergrundwechsler (dieser)",
          "Szenenersatz nach dem Freistellen",
          "Café-, Büro-, Markenwand-Atmosphäre"
        ]
      ],
      "vsP": "Die vier Leitfäden vernetzen, aber Keywords ehrlich halten. Weiße Produktplatten gehören nicht in einen Lifestyle-Szenen-Artikel, und Visa-Blau-Ausweisfotos nicht in einen Café-Komposit-Pitch.",
      "troubleTitle": "Wenn die neue Szene falsch aussieht",
      "troubleCols": [
        "Problem",
        "Ursache",
        "Fix"
      ],
      "troubleRows": [
        [
          "Heller Fransenrand ums Motiv",
          "Freisteller noch schmutzig",
          "Zur Entfernung mit kontrastreicherem Original zurück"
        ],
        [
          "Wirkt wie ein Sticker",
          "Fehlender Kontakt oder Lichtmismatch",
          "Platte weicher machen oder sehr leichten Kontaktschatten ergänzen"
        ],
        [
          "Haut wird grau oder orange",
          "Farbtemperatur-Konflikt",
          "Nähere Temperatur-Szene wählen oder Gradation vereinheitlichen"
        ],
        [
          "Haare wirken schmutzig",
          "Unvollständiges Alpha um Strähnen",
          "Freisteller vor erneutem Komponieren säubern"
        ],
        [
          "Produktform driftet in KI-Szene",
          "Generierung hat das Objekt verändert",
          "Identität sperren; KI nur die Umgebung erfinden lassen"
        ]
      ],
      "prosConsTitle": "Was dieser Workflow freigibt",
      "bestTitle": "Ersetzungen, die auf dem Handy halten",
      "bestItems": [
        "Sauberen transparenten Master nie überspringen.",
        "Der Kanal entscheidet die Szene: Recruiting bleibt ruhig, Lifestyle darf atmen, Poster brauchen Titelplatz.",
        "Einfaches Quelllicht macht den Ersatz leichter.",
        "Vor dem Posten immer auf Handygröße prüfen.",
        "Headline-Text erst ergänzen, wenn die Szene steht—GPT Image hilft bei Poster-Schrift.",
        "Marktplatz-Weiß-SKUs an den E-Commerce-Leitfaden senden, damit Intents getrennt bleiben."
      ],
      "miralTitle": "Die Kette in Miral AI behalten",
      "miralP": "Empfohlener Pfad in Miral AI: Background Remover → optional Image Enhancer → Seedream oder FLUX.2 für die Umgebung → GPT Image bei Bedarf für Poster-Schrift. Für ausweisähnliche Weiß- oder Blaukarten zurück zum Porträt-Leitfaden.",
      "miralLinksTitle": "Nächste Schritte",
      "intentsTitle": "Häufige Hintergrundwechsel-Jobs",
      "faqTitle": "Praktische Fragen",
      "faqItems": [
        [
          "Wie ändere ich einen Fotohintergrund online kostenlos?",
          "Bei Miral AI anmelden, mit Background Remover ein transparentes PNG exportieren, dann das Motiv auf Café, Markenwand oder neue Szene setzen."
        ],
        [
          "Wie mache ich aus einem transparenten PNG ein Lifestyle-Bild?",
          "Auf eine Platte mit passendem Licht komponieren, Kontakt und Farbtemperatur prüfen, Master und Cover-Zuschnitte getrennt halten."
        ],
        [
          "Wie ändere ich einen Social-Cover-Hintergrund nach dem Freistellen?",
          "Nachdem Haarkanten die Prüfung bestehen, Motiv auf eine Seite eines Markenverlaufs setzen und Platz für den Titel lassen."
        ],
        [
          "Kann ich einen Selfie-Hintergrund durch eine Café-Szene ersetzen?",
          "Ja. Zuerst sauber freistellen, dann in eine Caféplatte komponieren, deren Fensterlicht zum Gesicht passt."
        ],
        [
          "Kann man hinter einer realen Person eine neue KI-Szene generieren?",
          "Ja. Reales Motiv aus dem transparenten PNG behalten und Seedream oder FLUX.2 nur die Umgebung erfinden lassen."
        ],
        [
          "Welches Tool eignet sich für Event-Poster-Hintergrundersatz?",
          "Freisteller mit Miral AI Background Remover, auf weiche Markenwand setzen, bei Bedarf Headline-Schrift in GPT Image ergänzen."
        ],
        [
          "Welches Tool eignet sich für Social-Cover-Hintergrundersatz?",
          "Background Remover plus Markenfarbe oder Verlaufswand. Mit Seedream oder FLUX.2 fortsetzen, wenn eine vollere Lifestyle-Szene nötig ist."
        ],
        [
          "Wie behebe ich eine unecht wirkende Hintergrundkomposition?",
          "Fransen, Lichtrichtung und Farbtemperatur in dieser Reihenfolge prüfen. Bei schmutzigen Kanten zuerst zur Hintergrundentfernung zurück."
        ],
        [
          "Wie behebe ich Außenlicht-Mismatch beim Hintergrundwechsel?",
          "Sonnenrichtung abstimmen; hartes Mittags-Oberlicht auf einem für Innenlicht belichteten Gesicht vermeiden."
        ],
        [
          "Kann ich Hintergrundwechsel für ein Video-Cover nutzen?",
          "Ja. Zuschnitt im Cover-Verhältnis exportieren und das Motiv im Safe Area halten."
        ],
        [
          "Was ist der Unterschied zwischen Hintergrundentfernung und -wechsel?",
          "Entfernung liefert ein transparentes Motiv. Wechsel setzt dieses Motiv in eine neue Szene oder Farbe."
        ],
        [
          "Kann ich das für Amazon-Weißprodukt-Hintergründe nutzen?",
          "Nein. Marktplatz-Weißplatten gehören in den E-Commerce-Leitfaden; dieser Artikel ist für Lifestyle- und Cover-Szenen."
        ]
      ],
      "miralLinks": [
        {
          "label": "Miral AI Background Remover",
          "path": "/tools/background-remover"
        },
        {
          "label": "Porträt- und Ausweis-Leitfaden",
          "path": "/hub/articles/ai-portrait-background-remover"
        },
        {
          "label": "Allgemeiner AI-Hintergrundentfernungs-Leitfaden",
          "path": "/hub/articles/ai-background-remover-online"
        },
        {
          "label": "E-Commerce-Produkthintergrund-Leitfaden",
          "path": "/hub/articles/ecommerce-product-background-removal"
        },
        {
          "label": "AI Image Enhancer",
          "path": "/tools/image-enhancer"
        },
        {
          "label": "Seedream 5",
          "path": "/image-models/seedream-ai-image-generator"
        },
        {
          "label": "FLUX.2",
          "path": "/image-models/flux-2-ai-image-generator"
        },
        {
          "label": "GPT Image 1.5",
          "path": "/image-models/gpt-image-ai-image-generator"
        }
      ]
    },
    "linksTitle": "Szenen-Workflow in Miral AI aufbauen",
    "linksIntro": "Einmal freistellen, transparenten Master behalten, dann Lifestyle-Szenen, Cover oder Posterplatten ohne neue Maske erstellen.",
    "steps": [
      {
        "title": "Zuerst sauberes Motiv freistellen",
        "text": "Mit Miral AI Background Remover ein transparentes PNG herunterladen und Haar- oder Produktkanten prüfen."
      },
      {
        "title": "Gefühl der neuen Szene festlegen",
        "text": "Café, ruhiges Büro, Außenlicht oder Markenwand—passend zum Kanal wählen."
      },
      {
        "title": "Motiv in den neuen Hintergrund setzen",
        "text": "Auf Design-Leinwand komponieren oder mit Seedream / FLUX.2 bei passendem Licht fortsetzen."
      },
      {
        "title": "Licht, Maßstab und Kontakt prüfen",
        "text": "Auf Fransen, Farbkonflikt, falsche Größe und fehlendes Kontaktgefühl achten."
      },
      {
        "title": "Benötigten Zuschnitt exportieren",
        "text": "Cover- und Avatargrößen getrennt speichern und transparenten Master unberührt lassen."
      }
    ],
    "pros": [
      "Ein transparenter Master trägt viele Szenen",
      "Günstiger als jede Umgebung neu zu fotografieren",
      "Starker Fit für Social-Cover und Lifestyle-Frames",
      "Verbindet sauber mit Seedream- und FLUX.2-Szenenarbeit"
    ],
    "cons": [
      "Lichtmismatch wirkt sofort unecht",
      "Schmutzige Freistellerkanten verderben die ganze Komposition",
      "Marktplatz-Weiß-SKUs sollten den E-Commerce-Leitfaden nutzen",
      "Komplexe Perspektivszenen brauchen manchmal noch manuelle Politur"
    ],
    "tips": [
      {
        "title": "Kanten vor Atmosphäre",
        "text": "Nie einen Freisteller komponieren, der auf dunkler Leinwand noch einen Halo zeigt."
      },
      {
        "title": "Zuerst Licht abstimmen",
        "text": "Platten wählen, deren Hauptlicht zu Gesicht oder Produkt passt."
      },
      {
        "title": "Master getrennt halten",
        "text": "Transparentes PNG, Lifestyle-Export und Social-Zuschnitte sollten verschiedene Dateien sein."
      },
      {
        "title": "Platz für Schrift lassen",
        "text": "Poster-Hintergründe brauchen ruhigere Zonen, in denen eine Headline sitzen kann."
      },
      {
        "title": "Suchintentionen trennen",
        "text": "Amazon-Weißplatten an den E-Commerce-Artikel senden; diesen für Szenenwechsel behalten."
      }
    ],
    "scenarios": [
      {
        "title": "Fotohintergrund online kostenlos ersetzen",
        "text": "Motiv zuerst freistellen, dann auf neue Platte oder generierte Szene setzen."
      },
      {
        "title": "Café-Lifestyle-Porträthintergrund",
        "text": "Fensterlicht-Platte nutzen, die zur Gesichtsbeleuchtung passt."
      },
      {
        "title": "Bürohintergrund für ein Profifoto",
        "text": "Regale und Requisiten weicher halten als die Person."
      },
      {
        "title": "Markenfarben-Hintergrund für Social-Cover",
        "text": "Transparentes PNG auf Vollton oder weichem Verlauf mit Platz für den Titel."
      },
      {
        "title": "Hintergrund nach KI-Freistellung ändern",
        "text": "Nicht komponieren, bis Haar- und Jackenkanten den Zwei-Leinwand-Check bestehen."
      },
      {
        "title": "KI-Szene hinter einer realen Person",
        "text": "Seedream oder FLUX.2 den Raum erfinden lassen, nicht ein neues Gesicht oder Outfit."
      },
      {
        "title": "Event-Poster-Hintergrundersatz",
        "text": "Saubere Markenwände bevorzugen, damit Headline-Schrift lesbar bleibt."
      },
      {
        "title": "Außenlicht-Hintergrundtausch",
        "text": "Sonnenrichtung abstimmen; Mittags-Oberlicht auf weichem Indoor-Gesicht vermeiden."
      },
      {
        "title": "Unecht wirkende Hintergrundkomposition beheben",
        "text": "Fransen, Lichtrichtung und Farbtemperatur in dieser Reihenfolge prüfen."
      },
      {
        "title": "Vom transparenten PNG zum Lifestyle-Bild",
        "text": "Master archivieren, Cover-Zuschnitte getrennt exportieren."
      },
      {
        "title": "Nicht für Amazon-Weißhintergründe",
        "text": "Listing-Platten an den E-Commerce-Produktleitfaden senden."
      },
      {
        "title": "Porträt-Freistellung dann Szenenwechsel",
        "text": "Haarprüfung im Porträt-Workflow abschließen, dann diesen Szenen-Workflow öffnen."
      }
    ],
    "toolFaq": [
      {
        "q": "Wie ändere ich einen Fotohintergrund online kostenlos?",
        "a": "Anmelden, Originalhintergrund zu transparentem PNG entfernen, dann Motiv auf neue Szene oder Vollton setzen."
      },
      {
        "q": "Wie mache ich aus einem transparenten PNG ein Lifestyle-Bild?",
        "a": "Auf lichtpassende Platte komponieren, Kontakt und Farbtemperatur prüfen, Master von Cover-Zuschnitten trennen."
      },
      {
        "q": "Kann ich einen Selfie-Hintergrund durch eine Café-Szene ersetzen?",
        "a": "Ja. Person zuerst freistellen, dann in Caféplatte mit ähnlichem Fensterlicht komponieren."
      },
      {
        "q": "Kann man hinter einer realen Person eine neue KI-Szene generieren?",
        "a": "Ja. Reales Motiv behalten und Seedream oder FLUX.2 nur die Umgebung erstellen lassen."
      },
      {
        "q": "Welches Tool eignet sich für Event-Poster-Hintergrundersatz?",
        "a": "Background Remover für den Freisteller, auf ruhige Markenwand setzen, bei Bedarf Headline-Schrift ergänzen."
      },
      {
        "q": "Welches Tool eignet sich für Social-Cover-Hintergrundersatz?",
        "a": "Background Remover plus Markenfarbe oder Verlaufswand; mit Seedream oder FLUX.2 für vollere Lifestyle-Szenen fortsetzen."
      },
      {
        "q": "Wie behebe ich eine unecht wirkende Hintergrundkomposition?",
        "a": "Fransen säubern, Lichtrichtung abstimmen und Farbtemperatur vor dem Export vereinheitlichen."
      },
      {
        "q": "Wie behebe ich Außenlicht-Mismatch beim Hintergrundwechsel?",
        "a": "Sonnenrichtung abstimmen und Mittags-Oberlicht auf indoor-beleuchtetem Gesicht vermeiden."
      },
      {
        "q": "Kann ich Hintergrundwechsel für ein Video-Cover nutzen?",
        "a": "Ja. Cover-Verhältnis-Zuschnitt exportieren und Motiv im Safe Area halten."
      },
      {
        "q": "Kann ich das für Amazon-Weißprodukt-Hintergründe nutzen?",
        "a": "Nein. Für Marktplatz-Weißplatten den E-Commerce-Produkthintergrund-Leitfaden nutzen."
      }
    ],
    "links": [
      {
        "label": "Miral AI Background Remover",
        "path": "/tools/background-remover"
      },
      {
        "label": "Porträt- und Ausweis-Leitfaden",
        "path": "/hub/articles/ai-portrait-background-remover"
      },
      {
        "label": "Allgemeiner AI-Hintergrundentfernungs-Leitfaden",
        "path": "/hub/articles/ai-background-remover-online"
      },
      {
        "label": "E-Commerce-Produkthintergrund-Leitfaden",
        "path": "/hub/articles/ecommerce-product-background-removal"
      },
      {
        "label": "AI Image Enhancer",
        "path": "/tools/image-enhancer"
      },
      {
        "label": "Seedream 5",
        "path": "/image-models/seedream-ai-image-generator"
      },
      {
        "label": "FLUX.2",
        "path": "/image-models/flux-2-ai-image-generator"
      },
      {
        "label": "GPT Image 1.5",
        "path": "/image-models/gpt-image-ai-image-generator"
      }
    ]
  },
  "articles": {
    "ai-portrait-background-remover": {
      "title": "Kostenloser AI-Porträt-Hintergrundentferner für Headshots, Avatare und Ausweisfotos",
      "excerpt": "Aus einem unruhigen Selfie einen sauberen Headshot machen: Porträthintergrund kostenlos entfernen, transparentes PNG exportieren, dann Weiß, Blau oder Markenfarbe für LinkedIn, Lebenslauf und Avatare ergänzen.",
      "metaTitle": "Kostenloser AI-Porträt-Hintergrundentferner | Miral",
      "metaDescription": "Porträthintergründe mit Miral AI kostenlos entfernen. Haardetails behalten, transparente PNG-Freisteller exportieren und LinkedIn-Headshots oder ausweisähnliche Weiß- und Blaufotos bauen.",
      "target": {
        "label": "Porträt-Hintergrundentferner öffnen",
        "path": "/tools/background-remover"
      },
      "keywords": [
        "kostenloser Porträt Hintergrundentferner",
        "AI Headshot Hintergrund entfernen",
        "LinkedIn Foto Hintergrund entfernen",
        "Ausweisfoto Hintergrundentferner",
        "Avatar Hintergrund entfernen",
        "Hintergrund um Haare entfernen",
        "Lebenslauf Foto Weißhintergrund",
        "blaues Ausweisfoto online"
      ]
    },
    "ai-background-changer-online": {
      "title": "Kostenloser KI-Hintergrundwechsler: Alltagszenen, Social-Cover und Event-Poster",
      "excerpt": "Alten Hintergrund kostenlos entfernen, dann Personen in Café-Alltags-Szenen, Markenverlauf-Social-Cover oder Event-Poster-Wände setzen—ohne mit E-Commerce-Weißhintergrund-Intent zu konkurrieren.",
      "metaTitle": "Kostenloser KI-Hintergrundwechsler online | Miral",
      "metaDescription": "Fotohintergründe online mit Miral AI ändern: auf transparentes PNG freistellen, dann Café-Alltags-Bilder, Social-Cover und Event-Poster-Szenen bauen.",
      "target": {
        "label": "AI-Hintergrundentferner öffnen",
        "path": "/tools/background-remover"
      },
      "keywords": [
        "kostenloser AI Hintergrundwechsler",
        "Fotohintergrund online ersetzen",
        "Hintergrund nach Freistellung ändern",
        "AI Szenenersatz",
        "Lifestyle Hintergrundwechsler",
        "Café Hintergrund für Porträt",
        "Social Cover Hintergrund ersetzen",
        "transparentes PNG neuer Hintergrund"
      ]
    }
  }
}
